import Vue from 'vue';
// import Vuetify, { VLayout } from 'vuetify/lib/framework';
import Vuetify, { VLayout } from 'vuetify/lib'
// Vue.use(Vuetify);

// export default new Vuetify({
// });

Vue.use(Vuetify, {
    components: {
      VLayout,
    },
  })

  export default new Vuetify({
    theme: {
      dark: true,
      themes: {
        dark: {
          primary: '#FBA917',
          accent: '#939597',
        },
      },
    },
  })
